import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface SignupDialogContextType {
  isOpen: boolean;
  openSignupDialog: () => void;
  closeSignupDialog: () => void;
}

const SignupDialogContext = createContext<SignupDialogContextType | undefined>(undefined);

export const SignupDialogProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openSignupDialog = useCallback(() => setIsOpen(true), []);
  const closeSignupDialog = useCallback(() => setIsOpen(false), []);

  return (
    <SignupDialogContext.Provider value={{ isOpen, openSignupDialog, closeSignupDialog }}>
      {children}
    </SignupDialogContext.Provider>
  );
};

export const useSignupDialog = () => {
  const context = useContext(SignupDialogContext);
  if (!context) throw new Error("useSignupDialog must be used within SignupDialogProvider");
  return context;
};
